export const maskCharacters = (str: string | number, mask: string, n: number) => {
  return String(str).slice(0, -n).replace(/./g, mask) + String(str).slice(-n);
};
